import { useMutation } from '@tanstack/react-query'
import { PulseFilters } from 'api/pulse'
import { getFillPayNoticeByLocationCsv } from 'api/pulse/fillPayNoticeByLocation'
import fileDownload from 'js-file-download'
import { track } from 'lib/amplitude'

export function useFillPayNoticeByLocationDownloadCsv(query: PulseFilters) {
  return useMutation({
    mutationFn: async () => {
      track('button_click, pulse_download_csv_fill_pay_notice_by_location', {
        filters: query,
      })
      const data = await getFillPayNoticeByLocationCsv(query)
      fileDownload(data, 'fill_pay_notice_by_location.csv')
    },
  })
}
